/**
 * Ленивая загрузка VK ID SDK — только когда реально рисуется виджет входа.
 *
 * Версия запинена намертво: плавающий диапазон @<3.0.0 подтянул сломанный
 * UMD-билд 2.6.6 («t is not a function», VKCOM/vkid-web-sdk#44) и уронил вход
 * через VK на всех брендах разом. Обновлять только руками с проверкой.
 */
import { loadScriptOnce } from './loadScriptOnce'

const SCRIPT_SRC = 'https://unpkg.com/@vkid/sdk@2.6.5/dist-sdk/umd/index.js'
const SCRIPT_ID = 'vkid-sdk'

/** Возвращает window.VKIDSDK, подгрузив UMD-бандл при первом обращении. */
export async function ensureVkIdSdk(): Promise<any> {
  // Ветку сервера закрывает сам loadScriptOnce — он отвергает промис без window.
  if (!('VKIDSDK' in (globalThis as any))) {
    await loadScriptOnce(SCRIPT_SRC, { id: SCRIPT_ID })
  }

  const sdk = (window as any).VKIDSDK
  if (!sdk) throw new Error('VK ID SDK загрузился без window.VKIDSDK')
  return sdk
}
